import { useSyncExternalStore } from "react";
import SaveButton from "@/components/SaveButton";
import { RowSelectionStore } from "@/components/data-table/context/RowSelectionContext";

interface StoreGroupSaveButtonProps {
  store: RowSelectionStore;
  getHasSelectionChanges: () => boolean;
}

export const StoreGroupSaveButton = ({
  store,
  getHasSelectionChanges,
}: StoreGroupSaveButtonProps) => {
  const hasSelectionChanges = useSyncExternalStore(
    store.subscribe,
    getHasSelectionChanges,
  );

  return <SaveButton disabled={hasSelectionChanges ? false : undefined} />;
};
